import React from 'react';
import GameList from '../components/GameList';
import useSEO from '../hooks/useSEO';

function Store() {
  useSEO({
    title: 'Nightfall',
    description: 'Premium adult visual novels and dating sims from established creators.',
    url: 'https://nightfallshop.com/'
  });

  return (
    <div className="min-h-screen pt-24 md:pt-32 pl-0 md:ml-[280px] pr-2 lg:pr-5 overflow-x-hidden">
      <div className="w-full max-w-full">
        <GameList />
      </div>
    </div>
  );
}

export default Store;

